import React from "react";
import {Alert, Snackbar} from "@mui/material";

export const ToastContext = React.createContext(null);

/**
 * Centralise les notifications Snackbar (anciennement "crouton").
 * Utilisation : const { showToast } = useToast();
 *               showToast({ msg: "Succès", severity: "success" });
 */
export function ToastProvider({ children }) {
    const [toast, setToast] = React.useState(null);
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (toast) setOpen(true);
    }, [toast]);

    const showToast = React.useCallback((notification) => {
        setToast(notification);
    }, []);

    function handleClose() {
        setToast(null);
        setOpen(false);
    }

    const contextValue = React.useMemo(() => ({ showToast }), [showToast]);

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            {open && toast && (
                <Snackbar
                    open={open}
                    onClose={handleClose}
                    autoHideDuration={5000}
                >
                    <Alert
                        onClose={handleClose}
                        severity={toast.severity}
                        variant="filled"
                        sx={{ width: "100%" }}
                    >
                        {toast.msg}
                    </Alert>
                </Snackbar>
            )}
        </ToastContext.Provider>
    );
}

/** Hook utilitaire pour afficher une notification */
export function useToast() {
    const ctx = React.useContext(ToastContext);
    if (!ctx) throw new Error("useToast doit être utilisé dans ToastProvider");
    return ctx;
}

